import { FC, useState } from 'react';

import { Link, Text, TextList, VSpacing } from '@hh.ru/magritte-ui';
import { ChevronDownOutlinedSize16, ChevronUpOutlinedSize16 } from '@hh.ru/magritte-ui/icon';

import useTrls from 'hooks/translation/useTrls';

const REQUIREMENTS = [
    'AdCreate.AdForm.BannerVideo.technicalRequirements.item1',
    'AdCreate.AdForm.BannerVideo.technicalRequirements.item2',
    'AdCreate.AdForm.BannerVideo.technicalRequirements.item3',
    'AdCreate.AdForm.BannerVideo.technicalRequirements.item4',
];

const TrlKeys = {
    title: 'AdCreate.AdForm.BannerVideo.technicalRequirements.titleMagritte',
};

export const TechnicalRequirements: FC = () => {
    const [isOpen, setOpen] = useState(false);

    const trl = useTrls();

    return (
        <>
            <Link
                Element="button"
                onClick={() => setOpen(!isOpen)}
                iconRight={isOpen ? <ChevronUpOutlinedSize16 /> : <ChevronDownOutlinedSize16 />}
            >
                {trl(TrlKeys.title)}
            </Link>
            {isOpen && (
                <>
                    <VSpacing default={12} />
                    <TextList Element="ul">
                        {REQUIREMENTS.map((item) => (
                            <Text key={item}>{trl(item)}</Text>
                        ))}
                    </TextList>
                </>
            )}
        </>
    );
};
